// import "cordova-plugin-camera";
import React from 'react';

export default class VideoModule extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      imageUrl: '',
      test: '',
      error: '',
      new_data: ''
    }
    this.readBinaryVideoFile = this.readBinaryVideoFile.bind(this);
    this.resOnError = this.resOnError.bind(this);
  }
  componentDidMount() {  
    this.openCamera();
  }

  readBinaryVideoFile(fileEntry) {
    console.log('filentry: ', fileEntry);
    fileEntry.file(function (file) {
        var reader = new FileReader();

        reader.onloadend = function() {
            var blob = new Blob([new Uint8Array(this.result)], { type: "video/mp4" });
            console.log(blob);
            console.log('file', file, 'fileEntry', fileEntry);
            
        };

        reader.readAsArrayBuffer(file);

    }, this.resOnError);
}

resOnError(error) {
  console.log('error: ', error);
    alert("resOnError - " + error.code);
  }

  openCamera(selection) {

    // var srcType = navigator.camera.PictureSourceType.CAMERA;
    // var options = this.setOptions(srcType);
    
    const captureSuccess = function(mediaFiles) {
      var i, path, len;
      for (i = 0, len = mediaFiles.length; i < len; i += 1) {
        path = mediaFiles[i].fullPath;
        console.log('calling: ', path, ' resolution')
        
        if(window.cordova) window.resolveLocalFileSystemURL(path, this.readBinaryVideoFile, this.resOnError);
      }
      console.log(i);
      console.log(path);
      console.log(len);
    };

    const captureError = function(error) {
      // navigator.notification.alert('Error code: ' + error.code, null, 'Capture Error');
    };
    
    navigator.device.capture.captureVideo(captureSuccess, captureError, {limit:1, duration: 2});
    // navigator.camera.getPicture(function cameraSuccess(imageUri) {
    //   this.setState({imageUrl: imageUri})
    // }, function cameraError(error) {
    //   this.setState({error: error})
    // }, options);
  }
  
  render() {
    
    return (
      <div className="d-flex flex-column">
        <span>Step 1</span>
        <span>PERSONAL INFO</span>
        
        <span>{this.state.error}</span>
        <span>{JSON.stringify(this.state.imageUrl)}</span>
      </div>
    )
  }
}